export const DATA_VIEW_ENTRY_DETAILS_WRAPPER_CLASS = 'view-entry-details';
export const DATA_VIEW_EDIT_ENTRY_WRAPPER_CLASS = 'view-edit-entry';
export const DATA_VIEW_CREATE_ENTRY_WRAPPER_CLASS = 'view-create-entry';
export const DATA_VIEW_GENERAL_WRAPPER_CLASS = 'view-general-wrapper';
export const DATA_VIEW_ASK_FOR_USER_WRAPPER_CLASS = 'view-ask-for-user-wrapper';
